import * as React from "react"
import { Grid, FormControl, Select, MenuItem, Button } from '@material-ui/core';
import { MODULE_EMPTY_ERROR } from 'src/constants/NotificationMessageConstant';
import { getLocalStorageValue } from 'src/effects/utils/local-storage';
import { UserType } from 'src/constants/Enum/UserType';

export default class ReportsComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedRegionId: -1,
            selectedCountryId: -1,
            selectedModuleId: -1,
            countriesForSelectedRegion: [],
            isModuleValid: true,
        }

        this.handleRegionChange = this.handleRegionChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleModuleChange = this.handleModuleChange.bind(this);
        this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
        this.handleDownloadAllModule = this.handleDownloadAllModule.bind(this);
        this.handleDownloadAllModuleForecast = this.handleDownloadAllModuleForecast.bind(this);
    }

    componentDidMount() {
        if (this.props.countryRegions && (this.props.countryRegions.length === 1)) {
            this.setState({ selectedRegionId: this.props.countryRegions[0].id });
            this.props.countryRegions.map((cr: any, index: any) => {
                if (this.props.countryRegions[0].id === cr.id) {
                    const countriesForSelectedRegion = cr.countries;
                    this.setState({ countriesForSelectedRegion });
                }
            })
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.selectedSurveyId !== this.props.selectedSurveyId) {
            this.state = {
                selectedRegionId: -1,
                selectedCountryId: -1,
                selectedModuleId: -1,
                isModuleValid: true
            }
        }
    }

    handleRegionChange = (event: any) => {
        const selectedRegionId = event.target.value;
        this.setState({ selectedRegionId });
        this.setState({ selectedCountryId: -1 });

        if (selectedRegionId && selectedRegionId > 0) {
            this.props.countryRegions.map((cr: any, index: any) => {
                if (selectedRegionId && selectedRegionId === cr.id) {
                    const countriesForSelectedRegion = cr.countries;
                    this.setState({ countriesForSelectedRegion });
                }
            })
        }
        else {
            this.setState({ countriesForSelectedRegion: [] });
        }
    }

    handleCountryChange = (event: any) => {
        const selectedCountryId = event.target.value;
        this.setState({ selectedCountryId });
    }

    handleModuleChange = (event: any) => {
        const selectedModuleId = event.target.value;
        this.setState({ selectedModuleId });
        if (selectedModuleId > 0) {
            this.setState({ isModuleValid: true });
        }
    }

    handleDownloadExcel = () => {
        if (this.state.selectedModuleId > 0) {
            this.setState({ isModuleValid: true });
            this.props.handleDownloadExcel(this.state.selectedRegionId, this.state.selectedCountryId, this.state.selectedModuleId);
        }
        else {
            this.setState({ isModuleValid: false });
        }
    }

    handleDownloadAllModule = () => {
        this.props.handleDownloadAllModule(this.state.selectedRegionId, this.state.selectedCountryId, this.state.selectedModuleId);
    }

    handleDownloadAllModuleForecast = () => {
        this.props.handleDownloadAllModuleForecast(this.state.selectedRegionId, this.state.selectedCountryId, this.state.selectedModuleId);
    }

    render() {
        const loggedInUser = getLocalStorageValue('user');
        return (
            <Grid item={true} xs={12} sm={6}>
                <div>
                    <div className="panel panel-blue-filled">
                        <div className="panel-body">

                            <Grid container={true} spacing={24}>
                                <Grid item={true} sm={4}>
                                    &nbsp;
                                </Grid>
                                <Grid item={true} sm={8}>

                                    <Grid container={true} spacing={24}>
                                        <Grid item={true} sm={6}>
                                            <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                                                <Select
                                                    value={this.state.selectedRegionId}
                                                    onChange={this.handleRegionChange}
                                                    placeholder="All Regions"
                                                    className="selectControl"
                                                    autoWidth={true}>
                                                    {
                                                        this.props.countryRegions && (this.props.countryRegions.length > 0) &&
                                                        <MenuItem key={-1} value={-1}>All Regions</MenuItem>
                                                    }
                                                    {
                                                        this.props.countryRegions &&
                                                        this.props.countryRegions.map((r: any, index: any) => {
                                                            return <MenuItem key={index} value={r.id}>{r.region}</MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item={true} sm={6}>
                                            <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                                                <Select
                                                    value={this.state.selectedCountryId}
                                                    onChange={this.handleCountryChange}
                                                    placeholder="All Countries"
                                                    className="selectControl"
                                                    autoWidth={true}>

                                                    <MenuItem key={-1} value={-1}>All Countries</MenuItem>
                                                    {
                                                        this.state.countriesForSelectedRegion && this.state.countriesForSelectedRegion.map((c: any, index: any) => {
                                                            return <MenuItem key={index} value={c.id}>{c.name}</MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item={true} sm={12}>
                                            <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                                                <Select
                                                    value={this.state.selectedModuleId}
                                                    onChange={this.handleModuleChange}
                                                    placeholder="Select Module"
                                                    className="selectControl"
                                                    autoWidth={true}>

                                                    <MenuItem key={-1} value={-1}>Select Module</MenuItem>
                                                    {

                                                        loggedInUser.roleId === UserType.HQAdmin || loggedInUser.roleId === UserType.RegionalAdmin || loggedInUser.roleId === UserType.DataCollector ?
                                                            this.props.models && this.props.models.map((m: any, index: any) => {
                                                                let moduleCategory: any = "";
                                                                if (m.module_category && m.moduleCategory !== "") {

                                                                    if (m.module_category.length > 30) {
                                                                        moduleCategory = " (" + m.module_category.substring(0, 30) + "...)";

                                                                    }
                                                                    else {
                                                                        moduleCategory = " (" + m.module_category + ")";

                                                                    }
                                                                }
                                                                return <MenuItem key={index} value={m.id}>{m.name + moduleCategory}</MenuItem>
                                                            })
                                                            :
                                                            this.props.models && this.props.models.map((m: any, index: any) => {
                                                                if (m.module_type === "Forecast") {
                                                                    return <MenuItem key={index} value={m.id}>{m.name}</MenuItem>
                                                                }
                                                                return ''
                                                            })
                                                    }
                                                </Select>
                                                {!this.state.isModuleValid && <span className="errorMessage">{MODULE_EMPTY_ERROR}</span>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </div>

                        <Grid container={true} spacing={24}>
                            <Grid item={true} sm={4}>
                                <div className="panel-heading">
                                    Data Downloads
                                </div>
                            </Grid>

                            <Grid item={true} sm={8}>
                                <div className="btn-groups alignWrapper">
                                    {

                                        loggedInUser.roleId === UserType.HQAdmin || loggedInUser.roleId === UserType.RegionalAdmin || loggedInUser.roleId === UserType.DataCollector ?
                                            <div className="alignLeft">
                                                <Button size="medium" className="btn-white" variant="outlined" type="button" value="Download All Modules" onClick={this.handleDownloadAllModule}>
                                                    Download All
                                                    </Button>
                                            </div>
                                            :
                                            loggedInUser.roleId === UserType.DataManagerSupply || loggedInUser.roleId === UserType.DataManagerSupplyRegional ?
                                                <div className="alignLeft">
                                                    <Button size="medium" className="btn-white" variant="outlined" type="button" value="Download All Modules" onClick={this.handleDownloadAllModuleForecast}>
                                                        Download All
                                                    </Button>
                                                </div>
                                                : ''
                                    }
                                    <div className="grow" />
                                    <div className="alignRight">
                                        <Button size="medium" className="btn-white" variant="outlined" type="button" value="Download Excel" onClick={this.handleDownloadExcel}>
                                            Download by Module
                                        </Button>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>

                    </div>
                </div>
            </Grid>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/ReportsComponent.tsx